<template>
  <div class="d-flex align-center pa-5">
    <div class="grey--text mr-5">Item per page</div>
    <div style="width: 80px">
      <v-select
        color="primary"
        dense
        hide-details
        :items="form.list"
        v-model="form.itemsPerPage"
        @change="changeItemsPerPage"
      />
    </div>
    <v-spacer />
    <v-pagination
      v-model="form.page"
      @input="$emit('change-page', form.page)"
      :length="length"
      :total-visible="totalVisible"
    ></v-pagination>
  </div>
</template>

<script>
export default {
  props: {
    totalVisible: {
      type: Number,
      default: 7,
    },
    length: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 0,
    },
    itemsPerPage: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      form: {
        itemsPerPage: this.itemsPerPage,
        page: 1,
        list: [10, 20, 50, 80, 110, 160, 200],
      },
    };
  },
  watch: {
    // follow the parent when it changes the page / page size itself (e.g. back to page 1
    // after a filter or search change), otherwise the widget shows a stale page number
    page(value) {
      if (value > 0 && value !== this.form.page) this.form.page = value;
    },
    itemsPerPage(value) {
      if (value !== this.form.itemsPerPage) this.form.itemsPerPage = value;
    },
  },
  methods: {
    changeItemsPerPage() {
      this.form.page = 1;
      this.$emit("change-items-per-page", this.form.itemsPerPage);
    },
  },
};
</script>
